<template>
  <b-modal
    ref="defined-info-modal"
    hide-footer
    no-fade
  >
    <div v-for="(element, elementIndex) in definedElementData" :key="`defined-element-${elementIndex}`">
      <h4 class="defined-item-title">Detailed {{ element && element.type ? element.type : '' }} Information</h4>
      <b-row v-if="element.airline">
        <b-col cols="4">
          <p><strong>Airline:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.airline }}
        </b-col>
      </b-row>
      <b-row v-if="element.operator">
        <b-col cols="4">
          <p><strong>{{ element.type }} Operator:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.operator }}
        </b-col>
      </b-row>
      <b-row v-if="element.flightNo">
        <b-col cols="4">
          <p><strong>Flight Number:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.flightNo }}
        </b-col>
      </b-row>
      <b-row v-if="element.trainNo">
        <b-col cols="4">
          <p><strong>Train Number:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.trainNo }}
        </b-col>
      </b-row>
      <b-row v-if="element.ferryNo">
        <b-col cols="4">
          <p><strong>Ferry Number:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.ferryNo }}
        </b-col>
      </b-row>
      <b-row v-if="element.vesselName">
        <b-col cols="4">
          <p><strong>Cruise Vessel Name & Number:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.vesselName }}
        </b-col>
      </b-row>
      <b-row v-if="element.coachNo">
        <b-col cols="4">
          <p><strong>Coach Number:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.coachNo }}
        </b-col>
      </b-row>
      <b-row v-if="element.from">
        <b-col cols="4">
          <p><strong>Departing From:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.from }}
        </b-col>
      </b-row>
      <b-row v-if="element.departing">
        <b-col cols="4">
          <p><strong>Departing At:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.departing }}
        </b-col>
      </b-row>
      <b-row v-if="element.to">
        <b-col cols="4">
          <p><strong>Arriving To:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.to }}
        </b-col>
      </b-row>
      <b-row v-if="element.arriving">
        <b-col cols="4">
          <p><strong>Arriving At:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.arriving }}
        </b-col>
      </b-row>
      <b-row v-if="element.vehicleType">
        <b-col cols="4">
          <p><strong>Vehicle Type:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.vehicleType }}
        </b-col>
      </b-row>
      <b-row v-if="element.vesselType">
        <b-col cols="4">
          <p><strong>Vessel Type:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.vesselType }}
        </b-col>
      </b-row>
      <b-row v-if="element.touchdown">
        <b-col cols="4">
          <p><strong>Touches Down En Route At:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.touchdown }}
        </b-col>
      </b-row>
      <b-row v-if="element.journeyTime">
        <b-col cols="4">
          <p><strong>Journey Time:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.journeyTime }}
        </b-col>
      </b-row>
      <b-row v-if="element.cabin">
        <b-col cols="4">
          <p><strong>Cabin of Travel:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.cabin }}
        </b-col>
      </b-row>
      <b-row v-if="element.class">
        <b-col cols="4">
          <p><strong>Class of Carriage:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.class }}
        </b-col>
      </b-row>
      <b-row v-if="element.seat">
        <b-col cols="4">
          <p><strong>Class of Travel:</strong></p>
        </b-col>
        <b-col col="8">
          {{ element.seat }}
        </b-col>
      </b-row>
      <b-row v-if="element.checkedBaggage">
        <b-col cols="4">
          <p><strong>Baggage Allowance:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.checkedBaggage }}
        </b-col>
      </b-row>
      <b-row v-if="element.baggage">
        <b-col cols="4">
          <p><strong>Baggage:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.baggage }}
        </b-col>
      </b-row>
      <b-row v-if="element.reference">
        <b-col cols="4">
          <p><strong>Reference:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.reference }}
        </b-col>
      </b-row>
      <b-row v-if="element.airlineRef">
        <b-col cols="4">
          <p><strong>Airline Reference:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.airlineRef }}
        </b-col>
      </b-row>
      <b-row v-if="element.eTicketNo">
        <b-col cols="4">
          <p><strong>E-Ticket Number:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.eTicketNo }}
        </b-col>
      </b-row>
      <b-row v-if="element.ticketNo">
        <b-col cols="4">
          <p><strong>Ticket Number:</strong></p>
        </b-col>
        <b-col cols="8">
          {{ element.ticketNo }}
        </b-col>
      </b-row>
    </div>
  </b-modal>    
</template>

<script>
  import dayjs from '@/lib/dayjs'
  export default {
    data () {
      return {
        definedElementData: ''
      }
    },
    methods: {
      openModal (data) {
        this.$refs['defined-info-modal'].show()
        // Set data sorted by departing time
        this.definedElementData = data.sort((a, b) => {
          const timeA = dayjs(a.departing, 'HH:mm')
          const timeB = dayjs(b.departing, 'HH:mm')

          if (timeA.isBefore(timeB)) {
            return -1
          } else if (timeA.isAfter(timeB)) {
            return 1
          } else {
            return 0
          }
        })
      },
      getCabinTitle (type) {
        switch (type){
          case 'Flight':
            return 'Cabin of Travel'
          default:
            return 'Cabin of Travel'
        }
      }
    }
  }
</script>

<style scoped>
.defined-item-title {
  margin: 30px 0 30px 0;
}
</style>